// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"140":"279dd600","481":"85e10575","691":"c72cf2bf","784":"ddb316d5"}[chunkId] + ".css";
};